module.exports = __webpack_public_path__ + "static/3-8e683cc683e11481d75b9817f27995cd.jpg";